// Icon map object type
export type IMap = Record<
  string,
  {
    readonly viewDim: string
    readonly viewDimY?: string
    readonly paths: IPath[]
  }
>

// SVG path interface
export interface IPath {
  readonly d: string 
  readonly fillOpacity: string
}

// Icons map
const iconsMap: IMap = {
  // Outlined angle down
  angleDown: {
    viewDim: '16',
    viewDimY: '10',
    paths: [
      {
        d: 'M7.3782 9.59737L0.257605 2.47667C-0.0858945 2.13327 -0.0858945 1.57647 0.257606 1.23317L1.08811 0.40257C1.43091 0.0597696 1.9866 0.0591696 2.3302 0.40117L8 6.04437L13.6698 0.40107C14.0134 0.05907 14.5691 0.0597702 14.9119 0.40257L15.7424 1.23307C16.0859 1.57647 16.0859 2.13327 15.7424 2.47667L8.6218 9.59727C8.2784 9.94077 7.7216 9.94077 7.3782 9.59737Z',
        fillOpacity: '1',
      },
    ],
  },
  // Filled outlined angle left
  angleLeft: {
    viewDim: '36',
    paths: [
      {
        d: 'M13.4026 17.3782L20.5233 10.2576C20.8667 9.91415 21.4235 9.91415 21.7668 10.2576L22.5974 11.0881C22.9402 11.4309 22.9409 11.9866 22.5988 12.3302L16.9556 18L22.5989 23.6698C22.9409 24.0134 22.9402 24.5691 22.5974 24.9119L21.7669 25.7424C21.4235 26.0859 20.8667 26.0859 20.5233 25.7424L13.4027 18.6218C13.0592 18.2784 13.0592 17.7216 13.4026 17.3782Z',
        fillOpacity: '0.5',
      },
    ],
  },
  // Filled outlined angle right
  angleRight: {
    viewDim: '36',
    paths: [
      {
        d: 'M22.5974 18.6218L15.4767 25.7424C15.1333 26.0859 14.5765 26.0859 14.2332 25.7424L13.4026 24.9119C13.0598 24.5691 13.0592 24.0134 13.4012 23.6698L19.0444 18L13.4011 12.3302C13.0591 11.9866 13.0598 11.4309 13.4026 11.0881L14.2331 10.2576C14.5765 9.91414 15.1333 9.91414 15.4767 10.2576L22.5973 17.3782C22.9408 17.7216 22.9408 18.2784 22.5974 18.6218Z',
        fillOpacity: '0.5',
      },
    ],
  },
  // Filled outline close
  cross: {
    viewDim: '36',
    paths: [
      {
        d: 'M18 16.0407L22.9168 11.2254C23.2236 10.9249 23.721 10.9249 24.0279 11.2254L24.7699 11.9521C25.0762 12.252 25.0768 12.7382 24.7712 13.0389L19.7293 18L24.7712 22.9611C25.0767 23.2618 25.0762 23.748 24.7699 24.0479L24.0278 24.7746C23.721 25.0751 23.2236 25.0751 22.9168 24.7746L18 19.9593L13.0832 24.7746C12.7764 25.0751 12.279 25.0751 11.9722 24.7746L11.2301 24.0479C10.9238 23.748 10.9233 23.2618 11.2288 22.9611L16.2707 18L11.2288 13.0389C10.9232 12.7382 10.9238 12.252 11.2301 11.9521L11.9721 11.2254C12.279 10.9249 12.7764 10.9249 13.0832 11.2254L18 16.0407Z',
        fillOpacity: '0.5',
      },
    ],
  },
  // Solid hamburger
  hamburger: {
    viewDim: '36',
    paths: [
      {
        d: 'M9.64286 12.9172H26.3571C26.7122 12.9172 27 12.6269 27 12.2689V10.6483C27 10.2902 26.7122 10 26.3571 10H9.64286C9.2878 10 9 10.2902 9 10.6483V12.2689C9 12.6269 9.2878 12.9172 9.64286 12.9172ZM9.64286 19.3998H26.3571C26.7122 19.3998 27 19.1095 27 18.7515V17.1309C27 16.7728 26.7122 16.4826 26.3571 16.4826H9.64286C9.2878 16.4826 9 16.7728 9 17.1309V18.7515C9 19.1095 9.2878 19.3998 9.64286 19.3998ZM9.64286 25.8824H26.3571C26.7122 25.8824 27 25.5921 27 25.2341V23.6134C27 23.2554 26.7122 22.9652 26.3571 22.9652H9.64286C9.2878 22.9652 9 23.2554 9 23.6134V25.2341C9 25.5921 9.2878 25.8824 9.64286 25.8824Z',
        fillOpacity: '1',
      },
    ],
  },
}

export default iconsMap
